import React, { useState, useEffect } from "react"
import { PAYMENT_STATUS_SEARCH } from "../../helpers/api_endpoints"
import { post } from "../../helpers/api_helper"
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Alert,
  Label,
  Input,
  Badge,
  FormGroup,
} from "reactstrap"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { Trans, useTranslation } from "react-i18next"
import Select from "react-select"
import { ITEMS_PER_PAGE } from "helpers/pagination_helper"

document.title = "Payment Statuses"

function PaymentStatusesList() {
  const { i18n } = useTranslation()
  const [paymentStatuses, setPaymentStatuses] = useState([])
  const [successMsg, setSuccessMsg] = useState("")
  const [filters, setFilters] = useState({})
  const [name, setName] = useState("")
  const [status, setStatus] = useState(1)
  const [symbol, setSymbol] = useState("")
  const [countryId, setCountryId] = useState("")
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const [loading, setLoading] = useState(true)
  const paymentStatus = [
    { value: 1, label: "Active" },
    { value: 0, label: "Inactive" },
  ]
  const getTranslatedText = (titleArray, defaultText) => {
    const langMap = { en: 1, ar: 2, ur: 3, fa: 4, ps: 5 }
    const langKey = langMap[i18n.language] || 1
    const titleObj = titleArray?.find(item => item[langKey])
    return titleObj ? titleObj[langKey] : defaultText
  }

  useEffect(() => {
    const getPaymentStatuses = async () => {
      try {
        const response = await post(
          `${PAYMENT_STATUS_SEARCH}?paginate=${ITEMS_PER_PAGE}&page=${page}`,
          filters
        )
        const data = response.data
        setPaymentStatuses(data.data)
        setTotalPages(data.pagination.totalPages)
        setPage(data.pagination.currentPage)
        setLoading(false)
      } catch (error) {
        console.log(error)
      }
    }
    getPaymentStatuses()
  }, [page, filters])

  const handleFilter = (type, value) => {
    const filtvalues = { ...filters }
    if (value === "") {
      delete filtvalues[type]
    } else {
      switch (type) {
        case "name":
          setName(value)
          filtvalues.name = value
          break
        case "status":
          setStatus(value == 1 ? 2 : 1)
          filtvalues.status = value
          break
        default:
          break
      }
    }
    setFilters(filtvalues)
  }

  const handlePrevPage = () => {
    if (page > 1) {
      setPage(page - 1)
    }
  }

  const handleNextPage = () => {
    if (page < totalPages) {
      setPage(page + 1)
    }
  }

  console.log(paymentStatuses)

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Row>
            <Col xl={12}>
              <Card>
                {successMsg ? (
                  <Alert style={{ margin: "25px" }} color="success">
                    {successMsg}
                  </Alert>
                ) : null}
                <CardTitle>
                  <Link to="/payment-statuses/add">
                    <button
                      style={{ float: "right", marginRight: "20px" }}
                      className="btn btn-sm btn-primary"
                    >
                      <i className="dripicons-plus"></i> &nbsp;
                      <Trans>Create</Trans>
                    </button>
                  </Link>
                </CardTitle>
                <div style={{ margin: "25px" }}>
                  <div className="row">
                    <div style={{ margin: "25px" }}>
                      <div className="row">
                        <div className="form-group col-md-3 mt-2">
                          <Label className="form-label">
                            <Trans>Name</Trans>
                          </Label>
                          <Input
                            name="name"
                            className="form-control"
                            placeholder=""
                            type="text"
                            onChange={e => handleFilter("name", e.target.value)}
                            onKeyDown={e =>
                              handleFilter("name", e.target.value)
                            }
                          ></Input>
                        </div>
                        <div className="form-group col-md-2 mt-2">
                          <Label className="form-label">
                            <Trans>Status</Trans>
                          </Label>
                          <Select
                            name="orderStatusId"
                            options={paymentStatus}
                            className="form-control select2"
                            onChange={e => handleFilter("status", e.value)}
                          />
                        </div>
                      </div>
                    </div>
                    <CardBody>
                      <div className="table-responsive">
                        <Table className="table table-striped table-bordered mb-0">
                          <thead>
                            <tr>
                              <th>
                                <Trans>ID</Trans>
                              </th>
                              <th>
                                <Trans>Name</Trans>
                              </th>
                              <th>
                                <Trans>Symbol</Trans>
                              </th>
                              <th>
                                <Trans>Status</Trans>
                              </th>
                              <th>#</th>
                            </tr>
                          </thead>
                          <tbody>
                            {paymentStatuses.map((paymentStatus, index) => (
                              <tr key={index}>
                                <td>{paymentStatus.id}</td>
                                <td>
                              {getTranslatedText(
                                paymentStatus.named?.title,
                                paymentStatus.name
                              )}
                            </td>
                                <td>{paymentStatus.symbol}</td>
                                <td>
                                  {
                                    <Badge
                                      className={
                                        paymentStatus.status == 0
                                          ? "bg-danger"
                                          : "bg-success"
                                      }
                                    >
                                      <Trans>
                                        {paymentStatus.status == 0
                                          ? "inactive"
                                          : "active"}
                                      </Trans>
                                    </Badge>
                                  }
                                </td>
                                <td>
                                  <Link
                                    to={`/payment-statuses/edit/${paymentStatus.id}`}
                                  >
                                    <button className="btn btn-sm btn-info">
                                      <i className="dripicons-pencil"></i>{" "}
                                      &nbsp;
                                      <Trans>Edit</Trans>
                                    </button>
                                  </Link>{" "}
                                  &nbsp;
                                  <Link
                                    to={`/payment-statuses/remove/${paymentStatus.id}`}
                                  >
                                    <button className="btn btn-sm btn-danger">
                                      <i className="dripicons-trash"></i> &nbsp;
                                      <Trans>Remove</Trans>
                                    </button>
                                  </Link>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                      <br></br>
                      <div className="text-center">
                        {/* Pagination controls */}
                        <button
                          className="btn btn-sm btn-dark"
                          onClick={handlePrevPage}
                          disabled={page === 1}
                        >
                          <Trans>Previous</Trans>
                        </button>
                        &nbsp;
                        <button
                          className="btn btn-sm btn-dark"
                          onClick={handleNextPage}
                          disabled={page === totalPages}
                        >
                          <Trans>Next</Trans>
                        </button>
                      </div>
                    </CardBody>
                  </div>
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default PaymentStatusesList
